import { render, staticRenderFns } from "./CommentStyle.vue?vue&type=template&id=34cf1960"
import script from "./CommentStyle.vue?vue&type=script&lang=js"
export * from "./CommentStyle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports